import { CardsTotalsByAccountData } from 'core/tarjeta/models/CardsTotalsByAccountData';
import { Periodo } from 'shared/models/Periodo';
import { formatCurrency } from 'shared/utils';
import { CardsTotalsTableWithPagination } from '../CardsTotalsTableWithPagination/CardsTotalsTableWithPagination';
import { Table } from 'shared/table';
import { Col, Row } from 'react-bootstrap';

export const CardsTotalsInfo = (props: {
  numeroCuenta: string;
  cardsTotals: CardsTotalsByAccountData;
  periodo: Periodo;
}) => {
  return (
    <>
      <Row>
        <Col></Col>
        <Col className="col-md-auto">
          <Table
            thead={
              <tr data-testid="head">
                <th>Totales</th>
                <th>$</th>
              </tr>
            }
            tbody={
              <>
                <tr data-testid="consumos">
                  <td>Consumos</td>
                  <td className="align-left">
                    {formatCurrency(props.cardsTotals.totalesCuenta.consumos)}
                  </td>
                </tr>
                <tr data-testid="acreditacioens">
                  <td>Acreditaciones</td>
                  <td className="align-left">
                    {formatCurrency(props.cardsTotals.totalesCuenta.acreditaciones)}
                  </td>
                </tr>
                <tr data-testid="extracciones">
                  <td>Extracciones</td>
                  <td className="align-left">
                    {formatCurrency(props.cardsTotals.totalesCuenta.adelantos)}
                  </td>
                </tr>
                <tr data-testid="otros">
                  <td>Otros</td>
                  <td className="align-left">
                    {formatCurrency(props.cardsTotals.totalesCuenta.otros)}
                  </td>
                </tr>
              </>
            }
          />
        </Col>
        <Col></Col>
      </Row>
      <Row>
        <Col>
          <CardsTotalsTableWithPagination
            numeroCuenta={props.numeroCuenta}
            totalesPorTarjeta={props.cardsTotals.totalesTarjeta}
            periodo={props.periodo}
          />
        </Col>
      </Row>
    </>
  );
};
